var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-sticky',[_c('div',{staticClass:"titles-style between-center"},[_c('van-icon',{attrs:{"name":"arrow-left","size":"20"},on:{"click":_vm.goBack}}),_c('div',{staticClass:"t1"},[_vm._v(_vm._s(_vm.title))]),_c('van-icon',{staticStyle:{"opacity":"0"},attrs:{"name":"arrow-left","size":"20"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }